const BASE64URL_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

export function getSecureRandomBytes(byteLength: number): Uint8Array {
  if (!Number.isSafeInteger(byteLength) || byteLength <= 0) {
    throw new Error('byteLength must be a positive safe integer');
  }

  const cryptoProvider = globalThis.crypto;
  if (!cryptoProvider?.getRandomValues) {
    throw new Error('Secure random generation requires Web Crypto getRandomValues().');
  }

  const bytes = new Uint8Array(byteLength);
  cryptoProvider.getRandomValues(bytes);
  return bytes;
}

export function createHighEntropyToken(byteLength = 32): string {
  return toBase64Url(getSecureRandomBytes(byteLength));
}

export function isHighEntropyToken(value: unknown): value is string {
  return typeof value === 'string'
    && value.length >= 32
    && value.length <= 128
    && /^[A-Za-z0-9_-]+$/.test(value);
}

export function toBase64Url(bytes: Uint8Array): string {
  let result = '';
  let buffer = 0;
  let bits = 0;

  for (const byte of bytes) {
    buffer = (buffer << 8) | byte;
    bits += 8;
    while (bits >= 6) {
      bits -= 6;
      result += BASE64URL_ALPHABET[(buffer >> bits) & 0x3f];
    }
  }

  if (bits > 0) {
    result += BASE64URL_ALPHABET[(buffer << (6 - bits)) & 0x3f];
  }

  return result;
}
